<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-6">
        <ValidationProvider>
          <vs-input
            class="w-full"
            label="Nombre"
            v-model="account.name"
            placeholder="Nombre de la caja"
          >
          </vs-input>
          <span class="text-sm text-danger"></span>
        </ValidationProvider>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-6">
        <ValidationProvider>
          <vs-select
            placeholder="Seleccione un tipo"
            class="w-full"
            label="Tipos de caja"
            v-model="account.type"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in tiposCaja"
            />
          </vs-select>
        </ValidationProvider>
      </div>
      <div class="vx-col w-full mb-6">
        <div class="flex flex-wrap justify-end">
          <vs-button class="mr-3 mb-2" @click="storeAccount">Guardar</vs-button>
          <vs-button
            @click="$router.go(-1)"
            color="primary"
            type="border"
            class="mb-2"
            >Descartar</vs-button
          >
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      account: {
        type: '',
        name: '',
      },
      tiposCaja: [
        {
          text: 'Efectivo',
          value: 'CASH',
        },
        {
          text: 'Banco',
          value: 'BANK',
        },
      ],
    };
  },
  methods: {
    storeAccount() {
      if (this.account.name != '' && this.account.type) {
        this.$repositories.accounts.storeAccount(this.account).then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Caja creada',
            text: '¡La caja se creo correctamente!',
            position: 'top-right',
          });
          this.$router.go(-1);
        });
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'La informacion no esta completa',
          text: 'La caja no se creo correctamente.',
          position: 'top-right',
        });
      }
    },
  },
};
</script>

<style></style>
